import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const deleteService = createAsyncThunk(
  "schedule/deleteService",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.serviceDelete(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const deleteServiceSlice = createSlice({
  name: "deleteService",
  initialState,
  reducers: {
    clearDeleteServiceResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteService.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(deleteService.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const deleteServiceList = (state) => state.deleteService.value;
export const deleteServiceLoading = (state) => state.deleteService.loading;

export const {clearDeleteServiceResponse} = deleteServiceSlice.actions;

export default deleteServiceSlice.reducer;
